module.exports = __webpack_public_path__ + "static/media/administration-owner-welcome.2db431c9.svg";